import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueClickAway from "vue3-click-away"

import App from '~/vue/apps/Offices.vue'

// Main app
const main = async () => {
    const pinia = createPinia()
    const app = createApp(App)

    app.use(pinia)
    app.use(VueClickAway)
    
    return app.mount('#vue-offices')
}

// Execute async function
main().then(() => {
    console.log()
})